import React from 'react';
import {TouchableOpacity, View} from 'react-native';

import Icon from '/component/base/Icon';
import BasePopover from '/component/base/Popover';
import Text from '/component/base/Text';

import {styles} from './NewInfoPopover.style';
interface NewInfoPopoverProps {
  heading: React.ReactNode;
  body: React.ReactNode;
  popoverClose: () => void;
}

export const NewInfoPopover: React.FC<NewInfoPopoverProps> = ({
  heading = '',
  body = '',
  popoverClose,
}) => {
  const fontResizeProps = {
    allowFontScaling: true,
    maxFontSizeMultiplier: 2,
  } as const;

  return (
    <BasePopover padded={true}>
      <View style={styles.base}>
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.paddingRight}
            onPress={popoverClose}
            accessibilityRole="button"
            accessibilityLabel="Close">
            <Icon name="close" />
          </TouchableOpacity>
          <Text variant="heading" style={styles.heading} {...fontResizeProps}>
            {heading}
          </Text>
        </View>
        <View style={styles.body}>
          <Text style={styles.bodyText} {...fontResizeProps}>
            {body}
          </Text>
        </View>
      </View>
    </BasePopover>
  );
};

export default NewInfoPopover;
